// extracted by mini-css-extract-plugin
export default {"dropdown":"CaseImprovedConcern_dropdown__mNfXq"};